export default __webpack_public_path__ + "static/Invoices-66e6036951ae3a8692bf1f3db9804636.mp4";